import { Card, Clickable } from '@warp-ds/react';

import styles from './PopularDestinationsCard.module.css';

type PopularDestinationsCardProps = {
    src: string;
    alt: string;
    label: string;
    href: string;
    id: string;
};

//double label to prevent the absolute div from stealing the entire clickable area
export const PopularDestinationsCard = ({ src, alt, label, href, id }: PopularDestinationsCardProps) => (
    <Card className="rounded-16">
        <article aria-owns={`${id}-title`}>
            <div className={styles.aspectContainer}>
                <img src={src} loading="lazy" alt={alt} className="w-full object-cover" />
            </div>
            <div className={`absolute inset-x-0 bottom-0 p-16 pt-32 ${styles.overlay}`} aria-hidden="true">
                <span className="mb-0 s-text-inverted text-16 font-bold">{label}</span>
            </div>
            <h4 id={`${id}-title`} className="mb-0">
                <Clickable href={href} title={label}>
                    <span className="sr-only">{label}</span>
                </Clickable>
            </h4>
        </article>
    </Card>
);
